import CommentBoxFooter from './CommentBoxFooter';
import CommentBoxFooterV2 from '../../lego.editor_comment/CommentBoxFooter';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
export default withFeatureBranch({
    editor_comment: CommentBoxFooterV2
})(CommentBoxFooter);

//# sourceMappingURL=index.js.map